module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/_cache/bio-1.vue");


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/bio.md
// module id = 212
// module chunks = 0